<template>
  <li>
    <div class="space-y-4 md:space-y-6">
      <img
        class="mx-auto h-auto w-40 rounded-full md:w-56 md:h-auto"
        :src="image"
        :alt="first"
      />
      <div class="space-y-2">
        <div class="space-y-2">
          <div
            class="text-center text-white text-sm md:text-xl font-semibold tracking-widest uppercase blackFont"
          >
            <h4 v-for="(item, index) in nameSplit" :key="index">
              {{ item }}
            </h4>
            <br v-if="nameSplit.length <= 2" />
          </div>
          <div class="text-center text-xs md:text-lg uppercase">
            <p class="bookFont">RECORD</p>
            <p class="blackFont">{{ record }}</p>
            <br v-show="insta === 'kingsolomonjourney'" />
          </div>

          <div class="text-center text-xs md:text-lg font-medium uppercase">
            <p class="bookFont">WEIGHT</p>
            <p class="blackFont">{{ weight }}</p>
          </div>
          <div class="text-center text-xs md:text-lg font-medium uppercase">
            <p class="bookFont">HOMETOWN</p>
            <p class="blackFont">{{ hometown }}</p>
          </div>
          <div
            class="text-justify text-xs md:text-sm text-white lightFont leading-tight"
          >
            <v-clamp autoresize :max-lines="mxLines">
              {{ description }}
              <template #after="{ clamped }">
                <span class="inline-flex">
                  <button
                    type="button"
                    @click="toggleDropdown(clamped)"
                    class="inline-flex font-extrabold items-center px-3 text-md focus:outline-none text-black transition ease-in-out duration-150"
                  >
                    {{ clamped ? "More" : "Less" }}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-2 -mr-0.5 h-4 w-4 fill-current text-black"
                      viewBox="0 0 18 9"
                      v-show="clamped"
                    >
                      <path
                        class="a"
                        d="M9,13.5l9,9,9-9Z"
                        transform="translate(-9 -13.5)"
                      />
                    </svg>
                    <svg
                      v-show="!clamped"
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-2 -mr-0.5 h-4 w-4 fill-current text-black"
                      viewBox="0 0 18 9"
                    >
                      <path
                        class="a"
                        d="M9,22.5l9-9,9,9Z"
                        transform="translate(-9 -13.5)"
                      />
                    </svg>
                  </button>
                </span>
              </template>
            </v-clamp>
          </div>

          <a
            target="_blank"
            :href="`https://www.instagram.com/${insta}`"
            class="text-center text-xs mmd:text-sm sm:text-md md:text-xl sm:tracking-widest text-white blackFont pt-1 md:pt-2"
          >
            @{{ insta }}
          </a>

          <a
            target="_blank"
            :href="boxerRec"
            class="text-center cursor-pointer"
          >
            <img
              class="mx-auto h-4 w-auto mt-2"
              src="@/assets/images/boxrec.png"
              alt="BoxRec"
            />
          </a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import VClamp from "vue-clamp";
export default {
  name: "Boxer",
  components: {
    VClamp,
  },
  props: {
    first: {
      type: String,
      default: null,
    },
    last: {
      type: String,
      default: null,
    },
    record: {
      type: String,
      default: null,
    },
    weight: {
      type: String,
      default: null,
    },
    hometown: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    insta: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    boxerRec: {
      type: String,
      default: null,
    },
    fullName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mxLines: 4,
    };
  },
  methods: {
    toggleDropdown(clamped) {
      if (clamped) {
        this.mxLines = 999;
      } else {
        this.mxLines = 4;
      }
    },
  },
  computed: {
    nameSplit() {
      return this.fullName.split(" ");
    },
  },
};
</script>
